import { slider } from './modules/slider';
import { header_scroll } from './modules/header_scroll';
slider();
header_scroll();